import { render, staticRenderFns } from "./message-header.vue?vue&type=template&id=2f137d3d&scoped=true&"
import script from "./message-header.vue?vue&type=script&lang=js&"
export * from "./message-header.vue?vue&type=script&lang=js&"
import style0 from "./message-header.vue?vue&type=style&index=0&id=2f137d3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f137d3d",
  null
  
)

export default component.exports